import React, { useEffect, useState, useMemo } from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { SnackbarProvider } from "notistack";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AppConstant } from "const";
import App from "./App";
import { EventBusUtils } from "utils";

// Tích hợp Tabler Core CSS (JS not imported - we manage behavior via React)
import "@tabler/core/dist/css/tabler.min.css";

// MUI ThemeProvider giữ lại tối thiểu cho @mui/x-date-pickers
const buildMinimalTheme = (mode) => createTheme({
  palette: {
    mode,
    primary: { main: "#206bc4" },
  },
});

const resolveTheme = (mode) => {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return mode;
};

const Provider = () => {
  const queryClient = new QueryClient();
  const [themeMode, setThemeMode] = useState(() => {
    const stored = localStorage.getItem("tabler_theme") || "system";
    return resolveTheme(stored);
  });

  // Khởi tạo theme mode của Tabler lên body từ localStorage và lắng nghe sự kiện thay đổi theme
  useEffect(() => {
    document.body.setAttribute("data-bs-theme", themeMode);

    const handleThemeChange = (newTheme) => {
      setThemeMode(newTheme);
    };
    EventBusUtils.on("changeTheme", handleThemeChange);
    return () => EventBusUtils.off("changeTheme", handleThemeChange);
  }, [themeMode]);

  // Listen for OS theme changes when in "system" mode
  useEffect(() => {
    const stored = localStorage.getItem("tabler_theme") || "system";
    if (stored !== "system") return;
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => {
      const resolved = resolveTheme("system");
      setThemeMode(resolved);
      document.body.setAttribute("data-bs-theme", resolved);
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  const muiTheme = useMemo(() => buildMinimalTheme(themeMode), [themeMode]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={muiTheme}>
        <SnackbarProvider
          maxSnack={AppConstant.MAX_SNACKS}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

ReactDOM.render(<Provider />, document.getElementById("root"));
